import Requests from './Requests';

export default Requests;



// WEBPACK FOOTER //
// ./src/pages/Requests/index.ts